// extracted by mini-css-extract-plugin
module.exports = {"EventList":"EventList--3d9ci"};